export default "/images/38eb4a3f7277a92563f9126147848c5b.avif";